import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
/**
 * The shared Ask request publishes rows to its cache and store, but getResults needs a
 * Promise for each provider read. This bridge waits for that response, including one
 * that arrived before the read, and cancels readers without cancelling the shared request.
 */
export function createSuggestionRequests({ onResults, }) {
    const pendingRequests = new Map();
    let lastResponse;
    const settle = ({ query, suggestions }) => {
        lastResponse = { query, suggestions };
        onResults(suggestions);
        const pending = pendingRequests.get(query);
        if (!pending)
            return;
        pendingRequests.delete(query);
        pending.forEach((request) => {
            request.abortSignal.removeEventListener('abort', request.onAbort);
            request.resolve(suggestions);
        });
    };
    const wait = ({ query, abortSignal, }) => {
        if (abortSignal.aborted)
            return Promise.resolve(EMPTY_ARRAY);
        // The existing transport may complete before the SDK schedules its provider read.
        if (lastResponse?.query === query)
            return Promise.resolve(lastResponse.suggestions);
        return new Promise((resolve) => {
            const pending = {
                resolve,
                abortSignal,
                onAbort: () => {
                    const requests = pendingRequests.get(query);
                    requests?.delete(pending);
                    if (requests?.size === 0)
                        pendingRequests.delete(query);
                    resolve(EMPTY_ARRAY);
                },
            };
            const requests = pendingRequests.get(query) ?? new Set();
            requests.add(pending);
            pendingRequests.set(query, requests);
            abortSignal.addEventListener('abort', pending.onAbort, { once: true });
        });
    };
    return {
        invalidate: () => {
            lastResponse = undefined;
        },
        settle,
        wait,
        clear: () => {
            pendingRequests.forEach((requests) => requests.forEach((request) => {
                request.abortSignal.removeEventListener('abort', request.onAbort);
                request.resolve(EMPTY_ARRAY);
            }));
            pendingRequests.clear();
            lastResponse = undefined;
        },
    };
}
//# sourceMappingURL=createSuggestionRequests.js.map